export enum WinStatus {
    WINNING = "winning",
    OUTBID = "losing",
}

export type WinningStatus = {
    lotId: number;
    winStatus: WinStatus;
}